export default __webpack_public_path__ + "static/media/masthead.be9585a2.png";